type ComponentColor = "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning"

export const documentWorkspaceThemeConfig = {
   color: {
      light: 'rgba(0, 0, 0, 0.38)',
      actionTitle: 'rgba(0, 0, 0, 0.87)',
      hover: '#F5F5F5',
      tag: 'primary' as ComponentColor,
      remove: '#ED6C02',
      completed: '#43A047',
      hoverCellOutline: '1px solid rgba(51, 20, 53, 0.30)',
      selectedCellOutline: '1px solid rgba(51, 20, 53, 1)',
      disabledTitle: '#BDBDBD',
      moreMenuIcon: 'rgba(0, 0, 0, 0.26)',
      moreMenuIconSelected: 'rgba(0, 0, 0, 0)',
      utilityIconSelected: '#FFFFFF30',
      disabledOpacity: 0.26, // Opacity for a disabled item
      hoverOpacity: 0.60, // Opacity for a non disabled item (hover state),
   },
   sizes: {
      avatar: { width: 24, height: 24 }
   }
}
